module.exports = __webpack_public_path__ + "static/media/067-man-14.815b37df.svg";